import qs from "qs";

export default function getUrlParams(location) {
  return qs.parse(location.search.replace("?", ""));
}
